import axios from 'axios';
import config from '../config/env';
import { toast } from 'react-toastify';
import { authStateManager } from './authStateManager';

// Create the shared axios instance
const axiosInstance = axios.create({
  baseURL: config.API_URL,
});

// Add request interceptor for auth header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for 401 handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !authStateManager.isExpiredOrLoggedOut()) {
      // Clear token and update auth state
      localStorage.removeItem('token');
      delete axiosInstance.defaults.headers.common['Authorization'];
      authStateManager.handleExpired();
      
      // Show error message
      const errorMessage = error.response?.data?.message || 'Your session has expired. Please log in again.';
      toast.error(errorMessage);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 